/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TeamPermissionAssignmentDto = {
    id: string;
    role: TeamPermissionAssignmentDto.role;
};

export namespace TeamPermissionAssignmentDto {

    export enum role {
        EDITOR = 'Editor',
        MONITOR_RESPONDER = 'Monitor responder',
        CATALOG_EDITOR = 'Catalog editor',
        VIEWER = 'Viewer',
    }


}
